<template lang="html">
  <div>
    <v-dialog
      v-model="SendFileOneboxDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
    <v-overlay :value="progress">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-card :style="stylechat">
      <!-- select account -->
      <div v-if="status_edit === 'start'" class="pa-1">
        <v-layout row wrap justify-center align-center class="mt-3 pl-3 pr-3">
          <v-col
            cols="2"
            justify="center"
            align="start"
            class="pl-2 pr-0 pt-0 pb-0"
            @click="close()"
          >
            <v-icon class="fz-30">mdi-close</v-icon>
          </v-col>
          <v-col
            cols="8"
            justify="center"
            align="center"
            class="pa-0"
          >
            <span class="tab-title">{{$t('Dialog.Saveonebox.titleaccount')}}</span>
          </v-col>
          <v-col
            cols="2"
            justify="center"
            align="center"
            class="pr-2 pl-0 pt-0 pb-0"
            >
          </v-col>
        </v-layout>
        <v-divider class="mt-4 mb-2"></v-divider>
        <v-layout v-if="list_account.length !== 0" row wrap justify-start align-start class="mt-3 pl-5 pr-5 pb-5">
          <v-list
            subheader
            two-line
            class="list-overflow"
          >
            <template v-for="(item, index) in list_account">
              <v-list-item :key="item.account_id">
                <v-list-item-avatar class="mr-3" @click="openDialog(item, index, 'detail-note')">
                  <!-- <img v-if="item.profilepicture" :src="item.profilepicture" alt="" class="img-position">
                  <img v-else-if="item.type === 'user'" :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" class="img-position">
                  <img v-else-if="item.type === 'bot'" :src="`${publicPath}/assets/img/default_profile/bot-white.png`" alt="" class="img-position">
                  <img v-else-if="item.type === 'business'" :src="`${publicPath}/assets/img/default_profile/business-white.png`" alt="" class="img-position"> -->
                  <img :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" class="img-position">
                </v-list-item-avatar>
                <v-list-item-content @click="editStatus(item.account_id, 'selectfolder')">
                  <v-list-item-title class="font-list-title">{{item.account_name}}</v-list-item-title>
                  <!-- <v-list-item-subtitle v-html="item.note_data.text"></v-list-item-subtitle>
                  <v-list-item-subtitle>{{date(item.create_date)}} {{time(item.create_date)}}</v-list-item-subtitle> -->
                </v-list-item-content>
                <v-list-item-action @click="editStatus(item.account_id, 'selectfolder')">
                  <v-icon class="icon-color-edit">mdi-chevron-right</v-icon>
                </v-list-item-action>
              </v-list-item>
              <v-divider
                v-if="index < list_account.length - 1"
              ></v-divider>
            </template>
          </v-list>
        </v-layout>
        <v-layout v-else row wrap justify-center align-center class="pl-5 pr-5 pb-5 list-overflow">
          <h4>{{$t('Dialog.Saveonebox.noAccount')}}</h4>
        </v-layout>
      </div>
      <!-- select folder -->
      <div v-if="status_edit === 'selectfolder'" class="pa-1">
        <v-layout row wrap justify-center align-center class="mt-3 pl-3 pr-3">
          <v-col
            cols="2"
            justify="center"
            align="start"
            class="pl-2 pr-0 pt-0 pb-0"
            @click="editStatus('', 'start')"
          >
            <v-icon class="fz-30">mdi-chevron-left</v-icon>
          </v-col>
          <v-col
            cols="8"
            justify="center"
            align="center"
            class="pa-0"
          >
            <span class="tab-title">{{$t('Dialog.Saveonebox.titlefolder')}}</span>
          </v-col>
          <v-col
            cols="2"
            justify="center"
            align="center"
            class="pr-2 pl-0 pt-0 pb-0"
            >
          </v-col>
        </v-layout>
        <v-divider class="mt-4 mb-2"></v-divider>
        <v-layout v-if="list_folder.length !== 0" row wrap justify-start align-start class="mt-3 pl-5 pr-5 pb-5">
          <v-list
            subheader
            two-line
            class="list-overflow"
          >
            <template v-for="(item, index) in list_folder">
              <v-list-item :key="item.folder_id">
                <v-list-item-avatar class="mr-3" @click="openDialog(item, index, 'savefile')">
                  <v-icon class="icon-color">fa-solid fa-folder-open</v-icon>
                </v-list-item-avatar>
                <v-list-item-content @click="openDialog(item, index, 'savefile')">
                  <v-list-item-title class="font-list-title">{{item.folder_name}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider
                v-if="index < list_folder.length - 1"
              ></v-divider>
            </template>
          </v-list>
        </v-layout>
        <v-layout v-else row wrap justify-center align-center class="pl-5 pr-5 pb-5 list-overflow">
          <h4>{{$t('Dialog.Saveonebox.noFolder')}}</h4>
        </v-layout>
      </div>
    </v-card>
    <Warning :WarningDialog="WarningDialog" :WarningDialogDetail="WarningDialogDetail" @emitWarning="emitWarning" @closeAlertDialog="closeAlertDialog"/>
    <ErrorAlert :ErrorDialog="ErrorDialog" :ErrorDialogDetail="ErrorDialogDetail" @closeAlertDialog="closeAlertDialog"/>
  </v-dialog>
</div>
</template>

<script>
import { Momenttime } from '@/services'
import Warning from '@/components/Alert/Warning'
import ErrorAlert from '@/components/Alert/Error'

var _ = require('lodash')
export default {
  props: {
    SendFileOneboxDialog: Boolean,
    SendFileOneboxDetail: {}
  },
  data () {
    return {
      account_id: '',
      list_folder: [],
      tokenuser: '',
      data_user: {},
      publicPath: process.env.VUE_APP_BASE_PATH,
      DetailSendFileOneboxDialog: false,
      NoteDetail: {},
      EditSendFileOneboxDialog: false,
      CreatedSendFileOneboxDialog: false,
      ListBottomMenu: false,
      ListBottomItem: [],
      ErrorDialog: false,
      ErrorDialogDetail: {},
      WarningDialog: false,
      WarningDialogDetail: {},
      list_account: [],
      status_edit: 'start',
      progress: false,
      stylechat: {
        "--SendFileOnebox-HeaderColor": "white",
        "--SendFileOnebox-TabBackground": "white",
        "--SendFileOnebox-Icon": "gray",
        "--SendFileOnebox-IconActive": "#2662ae",
        "--SendFileOnebox-Background": "white",
        "--SendFileOnebox-FontSize": "18px",
        "--SendFileOnebox-FontSize-Title": "24px",
        "--SendFileOnebox-FontColor": "back",
        "--SendFileOnebox-FontSize-Status": "16px",
        "--SendFileOnebox-FontColor-Status": "grey",
        "--SendFileOnebox-Background-Input": "#E2E1E3",
        "--SendFileOnebox-Color-Button": "#EFF2FE",
        "--SendFileOnebox-FontColor-Button": "#2662ae",
        "--SendFileOnebox-FontColor-Block-Button": "#cb1002",
        "--SendFileOnebox-FontColor-Dis-Button": "#e2e1e3",
        "--SendFileOnebox-Btn-Confirm-Background": "#2662ae",
        "--SendFileOnebox-Btn-Confirm-Color": "white",
        "--SendFileOnebox-Btn-Confirm-FontSize": "18px",
        "--SendFileOnebox-Btn-Cancel-Background": "white",
        "--SendFileOnebox-Btn-Cancel-Color": "#2662ae",
        "--SendFileOnebox-Btn-Cancel-FontSize": "18px",
        "--SendFileOnebox-Btn-Leave-Background": "white",
        "--SendFileOnebox-Btn-Leave-Color": "#ff5252",
        "--SendFileOnebox-Btn-Leave-FontSize": "18px",
        "--SendFileOnebox-FontSize-Title-Edit": "20px"
      },
    }
  },
  components: {
    ErrorAlert,
    Warning,
  },
  watch: {
    SendFileOneboxDialog () {
      if (this.SendFileOneboxDialog) {
        // console.log(this.SendFileOneboxDetail)
        this.getAccount()
      }
    },
  },
  created () {
    // var user_profile = JSON.parse(this.$cookie.get('user-profile'))
    var user_profile = ''
    if (JSON.parse(this.$cookie.get('user-profile') == null)) {
      user_profile = JSON.parse(localStorage.getItem('user-profile'))
    } else {
      user_profile = JSON.parse(this.$cookie.get('user-profile'))
    }
    this.data_user = user_profile['account']['profile']
    this.tokenuser = this.data_user.tokenuser
  },
  methods: {
    editStatus (id, status) {
      if (status === 'start') {
        this.status_edit = 'start'
        this.getAccount()
      } else if (status === 'selectfolder') {
        this.status_edit = 'selectfolder'
        this.account_id = id
        this.progress = true
        this.axios.post(process.env.VUE_APP_API_EVENT + `/api/box/get_mainfolder_byaccountid`, {
          account_id: id
        }).then((response) => {
          // console.log(response.data.data)
          if (response.data.status === 'success') {
            this.progress = false
            this.list_folder = response.data.data
          } else {
            this.ErrorDialogDetail = {
              title: 'Error',
              text: this.$t('Alert.Fail.default.somethingWrong')
            }
            this.ErrorDialog = true
          }
        }).catch(err => {
          this.progress = false
          console.log(err)
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        })
      }
    },
    date (timestamp) {
      if (this.$cookie.get('language') === 'th') {
        return Momenttime.dayjsdatethai(timestamp)
      } else {
        return Momenttime.dayjsdateen(timestamp)
      }
    },
    time (timestamp) {
      if (this.$cookie.get('language') === 'th') {
        return Momenttime.dayjstimethai(timestamp)
      } else {
        return Momenttime.dayjstimethai(timestamp)
      }
    },
    close () {
      this.$emit('closeComponents', {
        name: 'sendonebox',
        value: false
      })
    },
    emitWarning (item) {
      // console.log(item)
      this.WarningDialog = false
      if (item.type === 'savefile') {
        this.saveFile(item.detail)
      }
    },
    closeAlertDialog (data) {
      // console.log(data)
      if (data.type === 'warning') {
        this.WarningDialog = data.value
      } else if (data.type === 'err') {
        this.ErrorDialog = data.value
      } else if (data.type === 'bottommenu') {
        this.ListBottomMenu = data.value
      }
    },
    openDialog (item, index, type) {
      if (type === 'savefile') {
        this.WarningDialogDetail = {
          title: this.$t('Alert.Sure'),
          text: this.$t('Alert.Saveonebox'),
          detail: item,
          index: index,
          type: 'savefile'
        }
        this.WarningDialog = true
      }
    },
    saveFile (item) {
      // console.log(item)
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_EVENT + `/api/box/savefile`, {
        account_id: this.account_id,
        folder_id: item.folder_id,
        tokenmessage: this.SendFileOneboxDetail.tokenmessage
      }).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          this.progress = false
          this.account_id = ''
          this.status_edit = 'start'
          this.ErrorDialogDetail = {
            title: 'Success',
            text: this.$t('Dialog.Saveonebox.sendFiletoOnebox')
          }
          this.ErrorDialog = true
          this.close()
        } else {
          this.progress = false
          this.ErrorDialogDetail = {
            title: 'Error',
            text: response.data.message
          }
          this.ErrorDialog = true
        }
      }).catch(err => {
        console.log(err)
        this.progress = false
        this.ErrorDialogDetail = {
          title: 'Error',
          text: err.response.data.message
        }
        this.ErrorDialog = true
      })
    },
    getAccount () {
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_EVENT + `/api/box/get_account_byuserid`, {
        user_id: this.tokenuser
      }).then((response) => {
        if (response.data.status === 'success') {
          this.progress = false
          this.list_account = response.data.data
          // console.log(this.list_account)
        } else {
          this.progress = false
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        }
      }).catch(err => {
        console.log(err)
        this.progress = false
        this.ErrorDialogDetail = {
          title: 'Error',
          text: this.$t('Alert.Fail.default.somethingWrong')
        }
        this.ErrorDialog = true
      })
    },
  }
}
</script>

<style lang="css" scoped>
>>>.v-list-item .v-list-item__title {
  line-height: 1.9 !important;
}
.font-list-title {
  font-weight: 600;
  color: var(--SendFileOnebox-FontColor) !important;
}
.width-100 {
  width: 100% !important;
}
.fz-30 {
  font-size: 30px !important;
}
.text-transform {
  text-transform: none;
}
.text-title {
  font-size: var(--SendFileOnebox-FontSize-Title) !important;
  color: var(--SendFileOnebox-FontColor) !important;
  font-weight: 600;
}
.text-title-edit {
  font-size: var(--SendFileOnebox-FontSize-Title-Edit) !important;
  color: var(--SendFileOnebox-FontColor) !important;
}
.tab-title {
  color: var(--SendFileOnebox-FontColor) !important;
  font-size: var(--SendFileOnebox-FontSize) !important;
  font-weight: 600;
}
.tab-title-status {
  color: var(--SendFileOnebox-FontColor-Status) !important;
  font-size: var(--SendFileOnebox-FontSize-Status) !important;
}
.text-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 70vw;
}
.checkbox-color {
  color: var(--SendFileOnebox-IconActive) !important;
}
>>>.v-application .elevation-10 {
  box-shadow: none !important;
}
>>>.theme--light.v-sheet {
  box-shadow: none !important;
}
.list-overflow {
  height: calc(100vh - 64px) !important;
  overflow-y: auto;
  /* background-color: bisque; */
  width: 100% !important;
}
.list-overflow::-webkit-scrollbar {
  width: 3px;
}

.list-overflow::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, .1);
}

.list-overflow-select {
  height: calc(100vh - 210px) !important;
  overflow-y: auto;
  /* background-color: bisque; */
  width: 100% !important;
}
.list-overflow-select::-webkit-scrollbar {
  width: 3px;
}

.list-overflow-select::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, .1);
}
/* >>>.v-input__slot {
  background-color: var(--SendFileOnebox-Background-Input) !important;
  border-radius: 10px !important;
} */
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  box-shadow: none !important;
  background-color: var(--SendFileOnebox-Background-Input) !important;
  border-radius: 10px !important;
}
>>>.v-dialog--fullscreen {
  border-radius: 0;
  margin: 0;
  height: 100%;
  position: fixed;
  /* overflow-y: auto; */
  top: 0;
  left: 0;
  overflow: hidden;
}
>>>.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none !important;
}
.icon-color-edit {
  color: var(--SendFileOnebox-Icon) !important;
}
.icon-color {
  color: var(--SendFileOnebox-IconActive) !important;
}
.btn-confirm {
  background-color: var(--SendFileOnebox-Btn-Confirm-Background) !important;
  color: var(--SendFileOnebox-Btn-Confirm-Color) !important;
  font-size: var(--SendFileOnebox-Btn-Confirm-FontSize) !important;
  font-weight: 600;
}
.btn-cancel {
  background-color: var(--SendFileOnebox-Btn-Cancel-Background) !important;
  color: var(--SendFileOnebox-Btn-Cancel-Color) !important;
  font-size: var(--SendFileOnebox-Btn-Cancel-FontSize) !important;
  font-weight: 600;
}
.btn-leave {
  background-color: var(--SendFileOnebox-Btn-Leave-Background) !important;
  color: var(--SendFileOnebox-Btn-Leave-Color) !important;
  font-size: var(--SendFileOnebox-Btn-Leave-FontSize) !important;
  font-weight: 600;
}
.img-position {
  object-fit: cover;
  object-position: 50% 0;
  border-style: solid;
  border-width: thin;
  border-color: #e8e8e8;
}
.layout-page {
  /* height: calc(100vh - 64px) !important; */
  height: 100vh !important;
  overflow: hidden !important;
  background-color: var(--SendFileOnebox-Background) !important;
}

.text-transform {
  text-transform: none;
}
.text-title {
  font-size: var(--SendFileOnebox-FontSize-Title) !important;
  color: var(--SendFileOnebox-FontColor) !important;
  font-weight: 600;
}
.tab-title {
  color: var(--SendFileOnebox-FontColor) !important;
  font-size: var(--SendFileOnebox-FontSize) !important;
  font-weight: 600;
}
.tab-title-status {
  color: var(--SendFileOnebox-FontColor-Status) !important;
  font-size: var(--SendFileOnebox-FontSize-Status) !important;
}
.text-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 70vw;
}
</style>
